import { IBSAdonisService } from "./IBSAdonisService";
import { Mixpanel } from "./MixPanel";
import { IbsResponse } from '../CommonProps'
import { IDS } from '../constants/Ids'

const taskListId: string = IDS.TASK_LIST.BOOKING;

const ibsAdonisService = new IBSAdonisService();

export const deleteBookingTask = async (estimateId: string) => {
  try {
    const tasks: IbsResponse = await ibsAdonisService.getTasksForUser(taskListId)
    const bookingTask = tasks?.Data?.filter(
      (x: any) =>
        x.assignments.filter((y: any) => y.assignedToId === estimateId).length > 0
    )[0];
    if (bookingTask) {
      const response = await ibsAdonisService.deleteTask(bookingTask.id);
      if (response?.IsSuccess) {
        Mixpanel.track("Booking Task Deleted", {
          bookingTask,
          bookingTaskId: bookingTask.id,
          estimateId: estimateId,
          status: "Booking Task Deleted successfully"
        });
      } else {
        Mixpanel.track("Booking Task Delete Error", {
          bookingTask,
          bookingTaskId: bookingTask.id,
          estimateId: estimateId,
          error: response?.Data?.errors[0]?.message || "",
          status: "Booking task not deleted"
        });
      }
    }
  } catch (err) {
    Mixpanel.track("Booking Task Delete Error", {
      estimateId: estimateId,
      exceptionError: err,
      status: "Booking task not deleted"
    });
  }
};
